/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';
import {RootScopeService} from "../../services/rootscope.service";
import {SessionService} from "../../services/session.service";
import {SharedService} from "../../services/shared.service";
import {HttpService} from "../../http/http.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Idle} from "@ng-idle/core";

@Component({
    selector: 'app-idle-popup',
    templateUrl: './idle-popup.component.html'
})
export class IdlePopupComponent implements OnInit {

    constructor(private rootScope: RootScopeService,
                private sessionService: SessionService,
                private sharedService: SharedService,
                private http: HttpService,
                private activeModal: NgbActiveModal,
                private idle: Idle) {
    }

    timeLeft: any;

    private sessionIdToPing: any;
    private onTimeoutWarning: any;

    ngOnInit(): void {
        const that = this;

        this.sessionIdToPing = this.sessionService.getCurrentSessionId();

        console.debug('Idle popup for session : ' + this.sessionIdToPing);

        //Get configured timeout
        var countdown = this.rootScope.get().properties.session.timeout;

        //Create object which represent time left
        this.timeLeft = {
            secondsLeft: countdown,
            minutesLeft: 0,
            hoursLeft: 0
        };
        this.timeLeft = this.convertTimeLeft(this.timeLeft);

        //Detect warn event (each seconds starting from idle event), update time left
        this.onTimeoutWarning = this.idle.onTimeoutWarning.subscribe(() => {
            console.warn('idle warn');
            countdown = countdown - 1;
            that.timeLeft = {
                secondsLeft: countdown,
                minutesLeft: 0,
                hoursLeft: 0
            };
            that.convertTimeLeft(that.timeLeft);
        })
    }

    ngOnDestroy() {
        this.onTimeoutWarning.unsubscribe()
    }

    private convertTimeLeft(timeLeft) {

        //If more than 59 seconds
        if (timeLeft.secondsLeft > 59) {

            //Get number of minutes
            timeLeft.minutesLeft = timeLeft.secondsLeft / 60;
            timeLeft.minutesLeft = timeLeft.minutesLeft - timeLeft.minutesLeft % 1;

            //Update seconds with what's left
            timeLeft.secondsLeft = timeLeft.secondsLeft % 60;

            //if more than 59 minutes
            if (timeLeft.minutesLeft > 59) {

                //Get number of hours
                timeLeft.hoursLeft = timeLeft.minutesLeft / 60;
                timeLeft.hoursLeft = timeLeft.hoursLeft - timeLeft.hoursLeft % 1;

                //Update minutes with what's left
                timeLeft.minutesLeft = timeLeft.minutesLeft % 60;

            }

        }
        return timeLeft;
    }

    //Ping the session
    ping() {
        const that = this;

        console.debug('Attempting a ping for session : ' + this.sessionIdToPing);

        this.http.getSession(this.sessionIdToPing).toPromise()
            .then(function (response) {
                if (response?.success) {
                    if ((response.result as any).extSessionId === that.sessionIdToPing) {
                        console.debug('Session is still valid');
                        that.activeModal.close('VALID');
                    } else {
                        console.warn('Error, session does not match');
                        that.activeModal.close('UNKNOWN');
                    }
                } else {
                    console.warn('Error, response false');
                    that.activeModal.close('UNVALID');
                }
            }, function (error) {
                console.warn('Error, could not get session : ' + error);
                that.activeModal.close('UNKNOWN');
            });
    };

}
